import { IoSearch } from "react-icons/io5";

const SearchInput = ({ placeholder, name, formik, onChange }) => {
  return (
    <div className="relative w-full">
      <div className="rounded-[5px] border border-[#D1A85580] overflow-hidden flex items-center gap-1 px-2 bg-sideBar">
        <IoSearch className="text-[#888888]" size={16} />
        <input
          type={"text"}
          name={name}
          placeholder={placeholder}
          onChange={onChange || (formik && formik.handleChange)}
          value={formik?.getFieldProps(name)?.value || ""}
          className="flex-1 h-8 py-2 bg-transparent focus-visible:outline-none placeholder:text-xs placeholder:text-[#9CA3AF]"
        />
      </div>
    </div>
  );
};

export default SearchInput;
